import {gql} from '@apollo/client';

export const QUERY_STUDY_LIST = gql`
  query StudyList($lesson: ID) {
    studyList(lesson: $lesson) {
      id
      attempt
      lessonId
      vocabularyResult
      finalResult
      trialResult
      vocabularyPassed
      trialPassed
      finalPassed
      phoneticsPassed
      intermediatePassed
      lesson {
        id
        level
        name
      }
    }
  }
`;

export const QUERY_STUDY_DETAIL = gql`
  query StudyDetail($id: ID!) {
    studyDetail(id: $id) {
      id
      attempt
      finalResult
      trialResult
      vocabularyResult
      vocabularyPassed
      trialPassed
      finalPassed
      phoneticsPassed
      intermediatePassed
    }
  }
`;

export const MUTATION_STUDY_PASS_LESSON = gql`
  mutation StudyPassLesson($input: StudyPassLessonInput!) {
    studyPassLesson(input: $input) {
      obj {
        id
        phoneticsPassed
        vocabularyPassed
        trialPassed
        finalPassed
        client {
          id
          currentLevel
          isRepeat
        }
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const MUTATION_STUDY_PASS_INTERMEDIATE = gql`
  mutation StudyPassIntermediate($input: StudyPassIntermediateInput!) {
    studyPassIntermediate(input: $input) {
      obj {
        id
        client {
          id
          currentLevel
          isRepeat
        }
      }
    }
  }
`;
